import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { awsImage } from '@firsttable/functions';
import { Box, Container, Row, Col, Title, Link } from '../../atoms';
import { Blackout, CityWrapper, CityInfo, CityInfoWrapper } from './styles';

type FeaturedCity = {
  id: string | number;
  menuTitle?: string;
  slug?: string;
  scenicPhoto: { basePath?: string };
};

type FeaturedStates = {
  edges: {
    node: {
      id: string | number;
      title?: string;
      cities: FeaturedCity[];
    };
  }[];
};

type FeaturedCitiesProps = {
  states?: FeaturedStates;
  NavLinkComponent: React.ElementType;
};

const emptyStates: FeaturedStates = { edges: [] };

const FeaturedCities = ({
  states = emptyStates,
  NavLinkComponent,
}: FeaturedCitiesProps) => {
  const space = 85;
  const imgCover = (cover, highRes = false) => {
    const imgWidth = 300;
    const imgHeight = Number((imgWidth / 1.135).toFixed());
    return awsImage(
      cover,
      highRes ? imgWidth * 2 : imgWidth,
      highRes ? imgHeight * 2 : imgHeight,
    );
  };
  return (
    <Container>
      <Row>
        {states.edges.map(({ node: { id, title, cities } }) => {
          // default widths
          const mobileStateWidth = 1;
          let tabletStateWidth = 1;
          let desktopStateWidth = 1;
          let mobileCityWidth = 1 / 2;
          const tabletCityWidth = 1 / 3;
          let desktopCityWidth = 1 / 4;

          if (cities.length === 1) {
            tabletStateWidth = 1 / 2;
            desktopStateWidth = 1 / 3;
            mobileCityWidth = 1;
            desktopCityWidth = 1;
          } else if (cities.length <= 5) {
            desktopCityWidth = 1 / cities.length;
          } else if (cities.length === 6) {
            desktopCityWidth = 1 / 3;
          }

          return (
            <Col
              mb={['xl', space - 20]}
              width={[
                mobileStateWidth,
                tabletStateWidth,
                desktopStateWidth,
                desktopStateWidth,
              ]}
              key={id}
            >
              <Title
                mb={['xl', 56]}
                textAlign="center"
                size={desktopStateWidth === 1 ? 'h2' : 'h4'}
              >
                {title}
              </Title>
              <Row gap={['s', 20]}>
                {cities.map(
                  ({
                    id: cityId,
                    menuTitle,
                    slug,
                    scenicPhoto: { basePath: cover },
                  }) => (
                    <Col
                      key={cityId}
                      mb={['s', 20]}
                      width={[
                        mobileCityWidth,
                        mobileCityWidth,
                        tabletCityWidth,
                        desktopCityWidth,
                      ]}
                      textAlign="center"
                    >
                      <CityWrapper>
                        <Box className="bg-pulse-animation" pb="88%" />
                        <LazyLoadImage
                          wrapperClassName="lazyload-img-wrapper"
                          srcSet={`${imgCover(cover)} 1x, ${imgCover(
                            cover,
                            true,
                          )} 2x`}
                          src={imgCover(cover)}
                          effect="opacity"
                          delayTime={5000}
                        />
                        <CityInfoWrapper>
                          <Blackout />
                          <CityInfo px="m">
                            <Box>
                              <Title
                                as="h3"
                                fontSize={['22px', '32px']}
                                color={null}
                                mb="xs"
                                m={0}
                              >
                                <Link
                                  NavComponent={NavLinkComponent}
                                  to={slug}
                                  expandClickableArea
                                >
                                  {menuTitle}
                                  <Box
                                    as="span"
                                    display="block"
                                    fontSize={['16px', '22px']}
                                    fontFamily="body"
                                  >
                                    restaurants
                                  </Box>
                                </Link>
                              </Title>
                            </Box>
                          </CityInfo>
                        </CityInfoWrapper>
                      </CityWrapper>
                    </Col>
                  ),
                )}
              </Row>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default FeaturedCities;
